
export default {
  props: {
    href: String,
    openNewTab: Boolean,
    color: String,
    style: Object,
  }
}
